import EditorComponent from './editor';
export default EditorComponent;
